import { action, observable } from 'mobx'

import Ds from './ds'
import sha1 from 'sha1'

class Quotes {
  @observable ds = new Ds()
  @observable quotes = []
  @observable itemDetail = {}
  @observable quoteHardware = []
  @observable quoteAccessory = []
  @observable quoteFeature = []
  @observable quoteDetail = []
  @observable newQuoteDetail = {}
  @observable quoteViewDetails = {
    agreementDetails: '',
    quoteId: 0,
    quoteType: 'accessory',
    status: 0,
    userFullName: ''
  }
  @observable serialNumbers = {}

  @action setQuoteViewDetails(params, callback) {
    this.quoteViewDetails = {
      agreementDetails: params.agreementDetails,
      paymentId: params.paymentId,
      quoteId: params.quoteId,
      quoteType: params.quoteType,
      status: params.status,
      userFullName: params.userFullName
    }

    if (callback) {
      return callback()
    }
  }

  @action loadQuotes(callback) {
    const query = `{
      quotes(
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        quoteType
        companyId
        company {
          defaultContactId
          name
          stripeCustomerId
        }
        organizationId
        userId
        user {
          firstName
          lastName
        }
        demo
        lease
        service {
          name
        }
        carrier {
          name
        }
        paymentInterval {
          name
        }
        contractTerm {
          terms
        }
        service {
          name
        }
        closeDate
        closePercentage
        hardwareTotal
        accessoriesTotal
        taxTotal
        oneTimeTotal
        serviceTotal
        featureTotal
        monthlyTotal
        token
        serialNumbers
        trackingNumber
        paymentId
        payment {
          qbPaymentNumber
          paymentTypeId
          amount
          approvalCode
          cardNumber
          cardType
          createdAt
        }
        createdAt
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res.quotes.length > 0) {

        this.quotes = res.quotes.map((q) => {
          q.demoName = (q.demo == 1 ? 'X' : '')

          q.leaseName = (q.lease == 1 ? 'X' : '')

          if (q.company) {
            q.companyName = q.company.name
            q.companyDefaultContactId = q.company.defaultContactId
            q.stripeCustomerId = q.company.stripeCustomerId
          }

          if (q.user) {
            q.userFirstName = q.user.firstName
            q.userLastName = q.user.lastName
            q.userFullName = q.user.firstName + ' ' + q.user.lastName
          }

          if (q.service) {
            q.serviceName = q.service.name
          }

          if (q.service) {
            q.serviceName = q.service.name
          }

          if (q.payment) {
            q.qbPaymentNumber = q.payment.qbPaymentNumber
            q.paymentTypeId = q.payment.paymentTypeId
            q.paymentAmount = q.payment.amount
            q.approvalCode = q.payment.approvalCode
            q.cardNumber = q.payment.cardNumber
            q.cardType = q.payment.cardType

            let dd = new Date(q.payment.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            q.formattedPaymentDate = dateString
          } else {
            q.qbPaymentNumber = null
            q.paymentTypeId = 0
            q.paymentAmount = 0.00
            q.approvalCode = null
            q.cardNumber = null
            q.cardType = null
            q.formattedPaymentDate = null
          }

          if (q.paymentInterval) {
            q.paymentIntervalName = q.paymentInterval.name
          }

          if (q.carrier) {
            q.carrierName = q.carrier.name
          }

          if (q.contractTerm) {
            q.contractTermName = q.contractTerm.terms
          }

          if (q.closeDate) {
            let dd = new Date(q.closeDate)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            q.formattedDate = dateString
          }

          if (q.createdAt) {
            let dd = new Date(q.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            q.formattedQuoteDate = dateString
          }

          return q
        })

        if (callback) {
          callback(this.quotes)
        }
      } else {
        this.quotes = []
      }
    })
  }

  @action newQuote(row, qbItemArray, qbTermArray, callback) {
    const query = `mutation {
      addQuote(
        organizationId: ${ localStorage.getItem('userOrganizationId')},
        companyId: ${ row.companyId},
        userId: ${ localStorage.getItem('userId')},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id,
        backendId,
        backend {
          name
        }
        serviceId,
        service {
          name
        }
        paymentIntervalId,
        paymentInterval {
          name
        }
        carrierId,
        carrier {
          name
        }
        activation,
        contractTermId,
        contractTerm {
          terms
        }
        paymentTermId
        billingAddressId,
        shippingAddressId,
        shippingTypeId,
        shippingType {
          name
        }
        shippingCost,
        note,
        closePercentage,
        agreementId,
        agreement {
          name
        }
        closeDate
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      res.addQuote.backendName = ''
      res.addQuote.serviceName = ''
      res.addQuote.paymentIntervalName = ''
      res.addQuote.carrierName = ''
      res.addQuote.paymentTermName = ''
      res.addQuote.contractTermName = ''
      res.addQuote.shippingTypeName = ''
      res.addQuote.agreementName = ''

      if (res.addQuote.backend) {
        res.addQuote.backendName = res.addQuote.backend.name
      }

      if (qbItemArray) {
        qbItemArray.map((qb) => {
          if (qb.id == res.addQuote.serviceId) {
            res.addQuote.serviceName = qb.name
          }
        })
      }

      if (qbTermArray) {
        qbTermArray.map((qb) => {
          if (qb.id == res.addQuote.paymentTermId) {
            res.addQuote.paymentTermName = qb.name
          }
        })
      }

      if (res.addQuote.paymentInterval) {
        res.addQuote.paymentIntervalName = res.addQuote.paymentInterval.name
      }

      if (res.addQuote.carrier) {
        res.addQuote.carrierName = res.addQuote.carrier.name
      }

      if (res.addQuote.contractTerm) {
        res.addQuote.contractTermName = res.addQuote.contractTerm.terms
      }

      if (res.addQuote.shippingType) {
        res.addQuote.shippingTypeName = res.addQuote.shippingType.name
      }

      if (res.addQuote.agreement) {
        res.addQuote.agreementName = res.addQuote.agreement.name
      }

      if (callback) {
        callback(res.addQuote)
      }
      console.log('Quote Info: ', res)
      this.newQuoteDetail = res

      return res.addQuote
    })
  }

  @action deleteQuote(id, callback) {
    let query = `mutation {
      deleteQuote(
        id: ${ id},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`

    this.ds.query(query, (data) => {
      if (callback) {
        callback()
      }
    })
  }

  @action loadQuote(quoteId, qbItemArray, qbTermArray, qbTaxRateArray, callback) {
    const query = `{
      quotes(
        id: ${ quoteId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        quoteType
        companyId
        company {
          name
        }
        userId
        user {
          firstName
          lastName
          email
        }
        demo
        lease
        backendId
        backend {
          name
        }
        serviceId
        service {
          name
          description
        }
        carrierId
        carrier {
          name
        }
        paymentIntervalId
        paymentInterval {
          name
        }
        activation
        activationWaived
        serialNumbers
        trackingNumber
        paymentId
        payment {
          qbPaymentNumber
          paymentTypeId
          amount
          approvalCode
          cardNumber
          cardType
          createdAt
        }
        shippingTypeId
        shippingType {
          name
        }
        shippingCost
        shippingAddressId
        shippingAddress {
          name
          address
          city
          state
          zipCode
          country
        }
        billingAddressId
        billingAddress {
          name
          address
          city
          state
          zipCode
          country
        }
        contractTermId
        contractTerm {
          terms
        }
        paymentTermId
        closeDate
        closePercentage
        note
        agreementId
        agreement {
          name
        }
        hardwareTotal
        accessoriesTotal
        taxTotal
        taxRateId
        oneTimeTotal
        serviceTotal
        featureTotal
        monthlyTotal
        createdAt
        qbItemList
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res.quotes.length > 0) {

        this.quoteDetail = res.quotes.map((q) => {
          q.demoName = (q.demo == 1 ? 'Demo' : '')
          q.leaseName = (q.lease == 1 ? 'Lease' : '')
          q.activation = q.activation.toFixed(2)
          q.shippingCost = q.shippingCost.toFixed(2)
          q.hardwareTotal = q.hardwareTotal.toFixed(2)
          q.accessoriesTotal = q.accessoriesTotal.toFixed(2)
          q.taxTotal = q.taxTotal.toFixed(2)
          q.taxRate = 0
          q.oneTimeTotal = q.oneTimeTotal.toFixed(2)
          q.serviceTotal = q.serviceTotal.toFixed(2)
          q.featureTotal = q.featureTotal.toFixed(2)
          q.monthlyTotal = q.monthlyTotal.toFixed(2)
          q.companyName = ''
          q.userFirstName = ''
          q.userLastName = ''
          q.userFullName = ''
          q.userEmail = ''
          q.backendName = ''
          q.serviceName = ''
          q.paymentIntervalName = ''
          q.carrierName = ''
          q.shippingTypeName = ''
          q.contractTermName = ''
          q.paymentTermName = ''
          q.shippingAddressName = ''
          q.shippingAddressAddress = ''
          q.shippingAddressCity = ''
          q.shippingAddressState = ''
          q.shippingAddressProvince = ''
          q.shippingAddressZipCode = ''
          q.shippingAddressCountry = ''
          q.billingAddressName = ''
          q.billingAddressAddress = ''
          q.billingAddressCity = ''
          q.billingAddressState = ''
          q.billingAddressProvince = ''
          q.billingAddressZipCode = ''
          q.billingAddressCountry = ''
          q.shippingTypeName = ''
          q.agreementName = ''

          if (q.company) {
            q.companyName = q.company.name
          }

          if (q.user) {
            q.userFirstName = q.user.firstName
            q.userLastName = q.user.lastName
            q.userFullName = q.user.firstName + ' ' + q.user.lastName
            q.userEmail = q.user.email

          }

          if (q.backend) {
            q.backendName = q.backend.name
          }

          if (qbItemArray) {
            qbItemArray.map((qb) => {
              if (qb.id == q.serviceId) {
                q.serviceName = qb.name
                q.serviceDescription = qb.description
              }
            })
          }

          if (qbTermArray) {
            qbTermArray.map((qb) => {
              if (qb.id == q.paymentTermId) {
                q.paymentTermName = qb.name
              }
            })
          }

          if (qbTaxRateArray) {
            qbTaxRateArray.map((qb) => {
              if (qb.id == q.taxRateId) {
                q.taxRateName = qb.name
                q.taxRate = qb.taxRate
              }
            })
          }

          /*
          if (q.service) {
            q.serviceName = q.service.name
            q.serviceDescription = q.service.description
          }
          */

          if (q.paymentInterval) {
            q.paymentIntervalName = q.paymentInterval.name
          }

          if (q.carrier) {
            q.carrierName = q.carrier.name
          }

          if (q.shippingType) {
            q.shippingTypeName = q.shippingType.name
          }

          if (q.contractTerm) {
            q.contractTermName = q.contractTerm.terms
          }

          if (q.shippingAddress) {
            q.shippingAddressName = q.shippingAddress.name
            q.shippingAddressAddress = q.shippingAddress.address
            q.shippingAddressCity = q.shippingAddress.city
            q.shippingAddressState = q.shippingAddress.state
            q.shippingAddressZipCode = q.shippingAddress.zipCode
            q.shippingAddressCountry = q.shippingAddress.country
          }

          if (q.billingAddress) {
            q.billingAddressName = q.billingAddress.name
            q.billingAddressAddress = q.billingAddress.address
            q.billingAddressCity = q.billingAddress.city
            q.billingAddressState = q.billingAddress.state
            q.billingAddressZipCode = q.billingAddress.zipCode
            q.billingAddressCountry = q.billingAddress.country
          }

          if (q.shippingType) {
            q.shippingTypeName = q.shippingType.name
          }

          if (q.agreement) {
            q.agreementName = q.agreement.name
          }

          if (q.createdAt) {
            let dd = new Date(q.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            q.formattedQuoteDate = dateString
          }

          return q
        })[0]

        if (callback) {
          callback(this.quoteDetail)
        }
      }
    })
  }

  @action loadQuoteByToken(token, emailStatus, callback) {
    const query = `{
      quoteToken(
        token: "${ token }"
        emailStatus: ${ emailStatus }
      ) {
        id
        organizationId
        quoteType
        companyId
        company {
          name
          stripeCustomerId
          defaultContactId
          defaultContact{
            email
          }
        }
        userId
        user {
          firstName
          lastName
          email
        }
        demo
        paymentId
        lease
        backendId
        backend {
          name
        }
        serviceId
        service {
          name
          description
        }
        carrierId
        carrier {
          name
        }
        paymentIntervalId
        paymentInterval {
          name
        }
        activation
        activationWaived
        serialNumbers
        shippingTypeId
        shippingType {
          name
        }
        shippingCost
        shippingAddressId
        shippingAddress {
          name
          address
          city
          state
          zipCode
        }
        billingAddressId
        billingAddress {
          name
          address
          city
          state
          zipCode
        }
        contractTermId
        contractTerm {
          terms
        }
        paymentTermId
        closeDate
        closePercentage
        note
        agreementId
        agreement {
          name
          agreement
        }
        hardwareTotal
        hardware {
          id
          sortId
          quoteId
          hardwareId
          description
          quantity
          cost
          serviceCost
          taxExempt
        }
        accessoriesTotal
        taxTotal
        taxRateId
        oneTimeTotal
        serviceTotal
        featureTotal
        monthlyTotal
        qbItemList
        qbTermList
        qbTaxRateList
        createdAt
        status
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res.quoteToken.length > 0) {

        this.quoteDetail = res.quoteToken.map((q) => {
          q.demoName = (q.demo == 1 ? 'Demo' : '')
          q.leaseName = (q.lease == 1 ? 'Lease' : '')
          q.activation = q.activation.toFixed(2)
          q.shippingCost = q.shippingCost.toFixed(2)
          q.hardwareTotal = q.hardwareTotal.toFixed(2)
          q.accessoriesTotal = q.accessoriesTotal.toFixed(2)
          q.taxTotal = q.taxTotal.toFixed(2)
          q.taxRate = 0
          q.oneTimeTotal = q.oneTimeTotal.toFixed(2)
          q.serviceTotal = q.serviceTotal.toFixed(2)
          q.featureTotal = q.featureTotal.toFixed(2)
          q.monthlyTotal = q.monthlyTotal.toFixed(2)
          q.companyName = ''
          q.stripeCustomerId = ''
          q.userFirstName = ''
          q.userLastName = ''
          q.userFullName = ''
          q.userEmail = ''
          q.backendName = ''
          q.serviceName = ''
          q.paymentIntervalName = ''
          q.carrierName = ''
          q.shippingTypeName = ''
          q.contractTermName = ''
          q.paymentTermName = ''
          q.shippingAddressName = ''
          q.shippingAddressAddress = ''
          q.shippingAddressCity = ''
          q.shippingAddressState = ''
          q.shippingAddressZipCode = ''
          q.billingAddressName = ''
          q.billingAddressAddress = ''
          q.billingAddressCity = ''
          q.billingAddressState = ''
          q.billingAddressZipCode = ''
          q.shippingTypeName = ''
          q.agreementName = ''

          if (q.company) {
            q.companyName = q.company.name
            q.stripeCustomerId = q.company.stripeCustomerId
            q.defaultContactId = q.company.defaultContactId

            if (q.company.defaultContact){
              q.defaultContactEmail = q.company.defaultContact.email
            }
          }

          if (q.user) {
            q.userFirstName = q.user.firstName
            q.userLastName = q.user.lastName
            q.userFullName = q.user.firstName + ' ' + q.user.lastName
            q.userEmail = q.user.email
          }

          if (q.backend) {
            q.backendName = q.backend.name
          }

          if (q.qbItemList) {
            q.quoteHardware = q.hardware.map((qh) => {
              qh.name = ''
              q.qbItemList.map((qb) => {
                if (qb.Id == qh.hardwareId) {
                  qh.hardwareName = qb.Name
    
                  //Check to see if a hardware description exists in the DB.  If not, use the QB description if available.
                  if (qh.description != null) {
                    qh.hardwareDescription = qh.description
                  } else {
                    qh.hardwareDescription = qb.Description
                  }
                }
              })
              return qh
            })
          } else {
            q.quoteHardware = []
          }

          if (q.qbTermList) {
            q.qbTermList.map((qb) => {
              if (qb.Id == q.paymentTermId) {
                q.paymentTermName = qb.Name
              }
            })
          }

          if (q.qbTaxRateList) {
            q.qbTaxRateList.map((qb) => {
              if (qb.Id == q.taxRateId) {
                q.taxRateName = qb.Name
                q.taxRate = qb.TaxRate
              }
            })
          }

          /*
          if (qbItemArray) {
            qbItemArray.map((qb) => {
              if (qb.id == q.serviceId) {
                q.serviceName = qb.name
                q.serviceDescription = qb.description
              }
            })
          }

          if (qbTermArray) {
            qbTermArray.map((qb) => {
              if (qb.id == q.paymentTermId) {
                q.paymentTermName = qb.name
              }
            })
          }

          if (qbTaxRateArray) {
            qbTaxRateArray.map((qb) => {
              if (qb.id == q.taxRateId) {
                q.taxRateName = qb.name
                q.taxRate = qb.taxRate
              }
            })
          }
          */

          if (q.paymentInterval) {
            q.paymentIntervalName = q.paymentInterval.name
          }

          if (q.carrier) {
            q.carrierName = q.carrier.name
          }

          if (q.shippingType) {
            q.shippingTypeName = q.shippingType.name
          }

          if (q.contractTerm) {
            q.contractTermName = q.contractTerm.terms
          }

          if (q.shippingAddress) {
            q.shippingAddressName = q.shippingAddress.name
            q.shippingAddressAddress = q.shippingAddress.address
            q.shippingAddressCity = q.shippingAddress.city
            q.shippingAddressState = q.shippingAddress.state
            q.shippingAddressZipCode = q.shippingAddress.zipCode
          }

          if (q.billingAddress) {
            q.billingAddressName = q.billingAddress.name
            q.billingAddressAddress = q.billingAddress.address
            q.billingAddressCity = q.billingAddress.city
            q.billingAddressState = q.billingAddress.state
            q.billingAddressZipCode = q.billingAddress.zipCode
          }

          if (q.shippingType) {
            q.shippingTypeName = q.shippingType.name
          }

          if (q.agreement) {
            q.agreementName = q.agreement.name
            q.agreementDetails = q.agreement.agreement
          }

          if (q.createdAt) {
            let dd = new Date(q.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            q.formattedQuoteDate = dateString
          }
          return q
        })[0]
        
        if (callback) {
          
          callback(this.quoteDetail)
        }
      }
    })
  }

  @action saveQuoteBillingAddress(row, callback) {
    const query = `mutation {
        updateQuote(
        id: ${ row.quoteId},
        billingAddressId: ${ row.addressId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        billingAddress {
          zipCode
        }
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      console.log('Update billing address')
      console.log(res.updateQuote)
      if (callback) {
        callback(res.updateQuote)
      }
    })
  }

  @action emailQuote(params, callback) {
    const query = `mutation {
      emailQuote(
        contactId: ${ params.contactId }
        token: "${ params.token }"
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (callback) {
        callback(res)
      }
    })
  }

  @action saveQuote(data, callback) {
    const query = `mutation {
      saveQuote(
        token: "${ sha1(data.companyId + '_' + localStorage.getItem('userOrganizationId') + '_' + (new Date().getTime()))}"
        accessoriesTotal: ${ data.accessoriesTotal},
        activation: ${ data.activation},
        agreementId: ${ data.agreementId},
        backendId: ${ data.backendId},
        billingAddressId: ${ data.billingAddressId},
        carrierId: ${ data.carrierId},
        closeDate: "${ data.closeDate}",
        closePercentage: ${ data.closePercentage},
        companyId: ${ data.companyId},
        contractTermId: ${ data.contractTermId},
        paymentTermId: ${ data.paymentTermId},
        demo: 0,
        featureTotal: ${ data.featureTotal},
        hardwareTotal: ${ data.hardwareTotal},
        hash: "${ localStorage.getItem('userHash')}",
        lease: 0,
        monthlyTotal: ${ data.monthlyTotal},
        note: "${ data.note}",
        oneTimeTotal: ${ data.oneTimeTotal},
        organizationId: ${ localStorage.getItem('userOrganizationId')},
        paymentIntervalId: ${ data.paymentIntervalId},
        quoteTypeId: 0,
        serviceId: ${ data.serviceId},
        serviceTotal: ${ data.serviceTotal},
        shippingAddressId: ${ data.shippingAddressId},
        shippingCost: ${ data.shippingCost},
        shippingTypeId: ${ data.shippingTypeId},
        status: ${ data.status},
        taxTotal: ${ data.taxTotal},
        taxRateId: ${ data.taxRateId},
        userId: ${ localStorage.getItem('userId')},
        quoteType: "${ data.quoteType}"
      ) {
        id,
        token
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (callback) {
        callback(res.saveQuote)
      }
    })
  }

  @action updateQuote(data, callback) {
    const query = `mutation {
      updateQuote(
        id: ${ data.quoteId},
        accessoriesTotal: ${ data.accessoriesTotal},
        activation: ${ data.activation},
        agreementId: ${ data.agreementId},
        backendId: ${ data.backendId},
        billingAddressId: ${ data.billingAddressId},
        carrierId: ${ data.carrierId},
        closeDate: "${ data.closeDate}",
        closePercentage: ${ data.closePercentage},
        companyId: ${ data.companyId},
        contractTermId: ${ data.contractTermId},
        paymentTermId: ${ data.paymentTermId},
        demo: 0,
        featureTotal: ${ data.featureTotal},
        hardwareTotal: ${ data.hardwareTotal},
        hash: "${ localStorage.getItem('userHash')}",
        lease: 0,
        monthlyTotal: ${ data.monthlyTotal},
        note: "${ data.note}",
        oneTimeTotal: ${ data.oneTimeTotal},
        organizationId: ${ localStorage.getItem('userOrganizationId')},
        paymentIntervalId: ${ data.paymentIntervalId},
        quoteTypeId: 0,
        serviceId: ${ data.serviceId},
        serviceTotal: ${ data.serviceTotal},
        shippingAddressId: ${ data.shippingAddressId},
        shippingCost: ${ data.shippingCost},
        shippingTypeId: ${ data.shippingTypeId},
        status: ${ data.status},
        taxTotal: ${ data.taxTotal},
        taxRateId: ${ data.taxRateId},
        userId: ${ localStorage.getItem('userId')},
        quoteType: "${ data.quoteType}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (callback) {
        callback(res.updateQuote)
      }
    })
  }

  @action saveQuoteSignature(data, callback) {
    const query = `mutation {
      saveQuoteSignature(
        id: ${ data.quoteId},
        signature: "${ data.signature}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (callback) {
        callback(res.updateQuote)
      }
    })
  }

  @action saveQuoteShippingAddress(row) {
    const query = `mutation {
      updateQuote(
        id: ${ row.quoteId},
        shippingAddressId: ${ row.addressId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {

    })
  }

  @action addQuoteHardware(row, callback) {
    const query = `mutation {
      addQuoteHardware(
        quoteId: ${ row.quoteId},
        sortId: ${ row.sortId},
        hardwareId: ${ row.hardwareId},
        description: "${ row.description}",
        quantity: ${ row.quantity},
        cost: ${ row.cost},
        serviceCost: ${ row.serviceCost},
        taxExempt: ${ row.taxExempt},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`
    console.log(query)
    this.ds.query(query, (res) => {
      //this.loadQuoteHardware(row.quoteId, qbItemArray, callback)
      if (callback != null) {
        callback(res)
      }
    })
  }

  @action deleteQuoteHardware(row, qbItemArray, callback) {
    let query = `mutation {
      deleteQuoteHardware(
        id: ${ row.id},
        hash: "${ row.hash}"
      ) {
        id
      }
    }`

    this.ds.query(query, (res) => {
      //this.loadQuoteHardware(row.quoteId, qbItemArray, callback)
    })
  }

  @action loadQuoteHardware(quoteId, qbItemArray, callback) {
    const query = `{
      quoteHardware(
        quoteId: ${ quoteId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        sortId
        hardwareId
        description
        quantity
        cost
        serviceCost
        taxExempt
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res.quoteHardware.length > 0) {
        this.quoteHardware = res.quoteHardware.map((qh) => {
          qh.name = ''
          qbItemArray.map((qb) => {
            if (qb.Id == qh.hardwareId) {
              qh.hardwareName = qb.Name

              //Check to see if a hardware description exists in the DB.  If not, use the QB description if available.
              if (qh.description != null) {
                qh.hardwareDescription = qh.description
              } else {
                qh.hardwareDescription = qb.Description
              }
            }
          })
          return qh
        })
      } else {
        this.quoteHardware = []
      }

      if (callback) {
        callback(res.quoteHardware)
      }
    })
  }

  @action loadItemDetails(id, qbItemArray, callback) {
    const query = `{
      quoteHardware(
        id: ${ id},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        hardwareId
        quantity
        cost
        serviceCost
        taxExempt
      }
    }`
    console.log(query)
    this.ds.query(query, (res) => {
      if (res.quoteHardware.length > 0) {

        let item = res.quoteHardware[0];

        //for(var qb in qbItemArray) {
        for (let i = 0; i < qbItemArray.length; i++) {
          if (qbItemArray[i].id == item.hardwareId) {
            item.hardwareName = qbItemArray[i].name
            item.hardwareDescription = qbItemArray[i].description

            if (callback) {
              callback(item)
            }
          }
        }
      }
    })
  }

  /*
  @action loadQuoteHardware(quoteId, callback) {
    const query = `{
      quoteHardware(
        quoteId: ${ quoteId },
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        hardwareId
        hardware {
          name
          description
        }
        quantity
        cost
        serviceCost
        taxExempt
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res.quoteHardware.length > 0) {
        this.quoteHardware = res.quoteHardware.map((qh) => {

          qh.quoteHardware = ''
          qh.hardwareDescription = ''
          qh.serviceName = ''

          if (qh.hardware != null) {
            qh.hardwareName = qh.hardware.name
            qh.hardwareDescription = qh.hardware.description
          }

          return qh
        })
      } else {
        this.quoteHardware = []
      }

      if (callback) {
        callback(res.quoteHardware)
      }
    })
  }
  */

  @action addQuoteAccessory(row, qbItemArray, callback) {
    const query = `mutation {
      addQuoteAccessory(
        quoteId: ${ row.quoteId},
        accessoryId: ${ row.accessoryId},
        quantity: ${ row.quantity},
        cost: ${ row.cost},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`

    this.ds.query(query, (res) => {
      //this.loadQuoteAccessory(row.quoteId, qbItemArray, callback)
    })
  }

  @action deleteQuoteAccessory(row, qbItemArray, callback) {
    let query = `mutation {
      deleteQuoteAccessory(
        id: ${ row.id},
        hash: "${ row.hash}"
      ) {
        id
      }
    }`

    this.ds.query(query, (res) => {
      //this.loadQuoteAccessory(row.quoteId, qbItemArray, callback)
    })
  }

  @action loadQuoteAccessory(quoteId, qbItemArray, callback) {
    const query = `{
      quoteAccessories(
        quoteId: ${ quoteId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        accessoryId
        quantity
        cost
      }
    }`

    this.ds.query(query, (res) => {
      if (res.quoteAccessories.length > 0) {
        this.quoteAccessory = res.quoteAccessories.map((qh) => {
          qh.accessoryName = ''
          qbItemArray.map((qb) => {
            if (qb.id == qh.accessoryId) {
              qh.accessoryName = qb.name
              qh.accessoryDescription = qb.description
            }
          })
          return qh
        })
      } else {
        this.quoteAccessory = []
      }

      if (callback) {
        callback(res.quoteAccessories)
      }
    })
  }

  /*
  @action loadQuoteAccessory(quoteId, qbItemArray, callback) {
    const query = `{
      quoteAccessories(
        quoteId: ${ quoteId },
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        accessoryId
        accessory {
          name
          description
        }
        quantity
        cost
      }
    }`

    this.ds.query(query, (res) => {
      if (res.quoteAccessories.length > 0) {
        this.quoteAccessory = res.quoteAccessories.map((qh) => {
          qh.accessoryName = qh.accessory.name
          qh.accessoryDescription = qh.accessory.description

          return qh
        })
      } else {
        this.quoteAccessory = []
      }

      if (callback) {
        callback(res.quoteAccessories)
      }
    })
  }
  */

  @action addQuoteFeature(row, qbItemArray, callback) {
    const query = `mutation {
      addQuoteFeature(
        quoteId: ${ row.quoteId},
        featureId: ${ row.featureId},
        quantity: ${ row.quantity},
        cost: ${ row.cost},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`

    this.ds.query(query, (res) => {
      //this.loadQuoteFeature(row.quoteId, qbItemArray, callback)
    })
  }

  @action deleteQuoteFeature(row, qbItemArray, callback) {
    let query = `mutation {
      deleteQuoteFeature(
        id: ${ row.id},
        hash: "${ row.hash}"
      ) {
        id
      }
    }`

    this.ds.query(query, (res) => {
      //this.loadQuoteFeature(row.quoteId, qbItemArray, callback)
    })
  }

  @action loadQuoteFeature(quoteId, qbItemArray, callback) {
    const query = `{
      quoteFeatures(
        quoteId: ${ quoteId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        featureId
        quantity
        cost
      }
    }`

    this.ds.query(query, (res) => {
      if (res.quoteFeatures.length > 0) {
        this.quoteFeature = res.quoteFeatures.map((qh) => {
          qh.featureName = ''
          qbItemArray.map((qb) => {
            if (qb.id == qh.featureId) {
              qh.featureName = qb.name
              qh.featureDescription = qb.description
            }
          })
          return qh
        })
      } else {
        this.quoteFeature = []
      }

      if (callback) {
        callback(res.quoteFeatures)
      }
    })
  }

  /*
  @action loadQuoteFeature(quoteId, qbItemArray, callback) {
    const query = `{
      quoteFeatures(
        quoteId: ${ quoteId },
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
        featureId
        feature {
          name
          description
        }
        quantity
        cost
      }
    }`

    this.ds.query(query, (res) => {
      if (res.quoteFeatures.length > 0) {
        this.quoteFeature = res.quoteFeatures.map((qh) => {
          qh.featureName = qh.feature.name
          qh.featureDescription = qh.feature.description

          return qh
        })
      } else {
        this.quoteFeature = []
      }

      if (callback) {
        callback(res.quoteFeatures)
      }
    })
  }
  */

  @action addQuoteNote(row, callback) {
    const query = `mutation {
      updateQuote(
        id: ${ row.quoteId},
        shippingTypeId: ${ row.shippingTypeId},
        shippingCost: ${ row.shippingCost},
        note: "${ row.note}",
        closeDate: "${ row.closeDate}",
        closePercentage: ${ row.closePercentage},
        agreementId: ${ row.agreementId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      this.loadQuote(row.quoteId, callback)
    })
  }

  @action quoteToOrder(quoteId, qbOrderNumber, orderStatus, callback) {
    let query = `mutation {
      quoteToOrder(
        quoteId: ${ quoteId},
        orderStatus: "${ orderStatus }",
        hash: "${ localStorage.getItem('userHash')}",
        qbOrderNumber: ${ qbOrderNumber},
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        callback(data)
      }
    })
  }

  @action loadQuoteSerialNumbers(quoteId, callback) {
    const query = `{
      quotes(
        id: ${ quoteId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
          serialNumbers
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
        this.serialNumbers = data.quotes[0]
        if (callback) {
          callback(this.serialNumbers)
        }
    })
  }

  @action saveSerialNumbers(id, serialNumbers, callback) {
    let query = `mutation {
      addSerialNumbers(
        id: ${ id },
        serialNumbers: "${ serialNumbers.trim().match(/([A-Z]*|[0-9]*)\w+/g).join(', ') }",
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (callback) {
        callback(data)
      }
    })
  }
}

export default new Quotes()



// WEBPACK FOOTER //
// ./src/stores/quotes.js